import { render, staticRenderFns } from "./Sidepanel.vue?vue&type=template&id=8a800878&"
import script from "./Sidepanel.vue?vue&type=script&lang=js&"
export * from "./Sidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports